import creditCardType from 'credit-card-type';
import { DEFAULT_LOCALE } from "./language-helpers";

export const trimValue = (value: string): string => value.trim();

export const findCardType = (cardNumber: string): string | null => {
  const value = cardNumber.substr(0, 4);
  // XXX: visa is set by default so we need to add validation for value length
  if (value.length < 4) {
    return null;
  }
  const match = creditCardType(value).find(
    item => ['visa', 'mastercard'].indexOf(item.type) > -1,
  );
  if (!match) {
    return null;
  }

  return match.type;
};

export const excludes = (needle: unknown, haystack: unknown[]): boolean =>
  haystack.includes(needle) === false;

export const copyToClipboard = (str: string): void => {
  if (typeof document === 'undefined') {
    return;
  }

  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  const selection = document.getSelection();
  const selected =
    selection && selection.rangeCount > 0
      ? selection.getRangeAt(0)
      : null;
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  if (selected && selection) {
    selection.removeAllRanges();
    selection.addRange(selected);
  }
};

export const getNumbersFromString = (str: string): string => str.replace(/[^\d.]/g, '');

export const removeWhitespaces = (str: string): string => str.replace(/\s/g, '');

export const parseAmount = (str: string): string => {
  return Number.parseFloat(str).toLocaleString('fullwide', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 12,
  });
};

export const matchStringByTagUl = (str: string): RegExpMatchArray | null =>
  str.replace(/\r?\n|\r|\t/g, '').match(/<ul>.*?<\/ul>/g);

export const getLocaleByLanguage = (lang: string): string => {
  const locales: Record<string, string> = {
    en: 'en-GB',
    ru: 'ru-RU',
    lv: 'lv-LV',
    es: 'es-ES',
    it: 'it-IT',
    fr: 'fr-FR',
    de: 'de-DE',
    pt: 'pt-PT',
    ko: 'ko-KR',
    ar: 'ar-AE',
    zh: 'zh-CN',
  };

  if (!locales[lang]) {
    return locales[DEFAULT_LOCALE];
  }

  return locales[lang];
};

export const getCsrf = (): string => {
  const metaElement = document.head.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null;
  const content = metaElement?.content || null;
  if (content === null) {
    throw new Error('Could not find csrf-token from tag META in HEAD section');
  }

  return content;
};
